import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-updates.component'

import MyUpdatesTab from './my-updates-tab'
import MyDevicesTab from './my-devices-tab'

let module = angular.module('myUpdates', [
  uiRouter,
  MyUpdatesTab,
  MyDevicesTab
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.manageMyRlink.myUpdates', {
      url: '/updates',
      component: 'myUpdates',
      redirectTo: 'vehicle.manageMyRlink.myUpdates.myUpdatesTab',
      authenticate: true
    })
})

.component('myUpdates', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/index.js